import { render } from "./HomeTransactions.vue?vue&type=template&id=da97ca30"
import script from "./HomeTransactions.vue?vue&type=script&lang=js"
export * from "./HomeTransactions.vue?vue&type=script&lang=js"
script.render = render

export default script